import axiosIns from '../../../xaxios';
import { obtenerUrlAPIPagos } from '../utils/funciones';

export default {
  async create(data) {
    return await axiosIns.post(obtenerUrlAPIPagos('listas-precios'), data);
  },
  async findAll(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos('listas-precios'), { params: opciones.params });
  },
  async findResumen(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos('listas-precios/resumen'), { params: opciones.params });
  },
  async findOne(id) {
    return await axiosIns.get(obtenerUrlAPIPagos(`listas-precios/${id}`));
  },
  async update(id, data) {
    return await axiosIns.patch(obtenerUrlAPIPagos(`listas-precios/${id}`), data);
  },
  async remove(id) {
    return await axiosIns.delete(obtenerUrlAPIPagos(`listas-precios/${id}`));
  },
  async consultarPreciosTodosLosTipos(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos('listas-precios/consultar-todos-tipos'), {
      params: opciones.params,
    });
  },
  async consultarPrecios(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos('listas-precios/consultar'), {
      params: opciones.params,
    });
  },
  async cambiarEstado(id, data) {
    return await axiosIns.patch(obtenerUrlAPIPagos(`listas-precios/${id}/cambiar-estado`), data);
  },
};
